<template>
	<div>
		<div class="row justify-content-center">
			<div class="col-lg-10 col-12">
				<!-- Carte principale -->
				<div v-if="ticketDatas && ticketDatas.totalttc" class="card shadow-sm rounded-3">
					<!-- En-tête avec montant -->
					<div class="card-header bg-primary text-white py-3">
						<h3 class="text-center mb-0 fw-bold">
							{{ price(ticketDatas.totalttc.value) }}
						</h3>
						<div v-if="rawexpense && rawexpense.exported_at" class="text-center mt-2 small">
							<i class="fas fa-file-export me-1"></i>
							Exporté le {{ formatDate(rawexpense.exported_at) }}
						</div>
					</div>
					<div class="card-body p-4">
						<!-- Warning doublon -->
						<div v-if="duplicates.length" class="alert alert-warning d-flex align-items-center mb-4">
							<i class="fas fa-exclamation-triangle me-2"></i>
							<div>
								Une note de frais du même montant existe déjà pour cet utilisateur à cette date.
								Vérifiez qu'il ne s'agit pas d'un doublon avant d'enregistrer.
							</div>
						</div>

						<!-- Infos principales -->
						<div class="row g-4 mb-4">
							<!-- Date -->
							<div class="col-md-6">
								<div class="d-flex align-items-center bg-light p-3 rounded-3 h-100">
									<i class="fas fa-calendar-alt fa-lg text-primary me-3"></i>
									<div class="fs-5">{{ formatDate(ticketDatas.date.value) }}</div>
								</div>
							</div>

							<!-- Catégorie -->
							<div class="col-md-6">
								<div class="d-flex align-items-center bg-light p-3 rounded-3 h-100">
									<template v-if="category === 'fuel'">
										<i class="fas fa-gas-pump fa-lg text-primary me-3"></i>
										<div class="fs-5">Carburant</div>
									</template>
									<template v-if="category === 'restaurant'">
										<i class="fas fa-utensils-alt fa-lg text-primary me-3"></i>
										<div class="fs-5">Restaurant</div>
									</template>
									<template v-if="category === 'restaurantclient'">
										<i class="fas fa-utensils-alt fa-lg text-primary me-3"></i>
										<div class="fs-5">Restaurant Client</div>
									</template>
									<template v-if="category === 'transportation'">
										<i class="fas fa-subway fa-lg text-primary me-3"></i>
										<div class="fs-5">Transport</div>
									</template>
									<template v-if="category === 'misc'">
										<i class="fas fa-money-check fa-lg text-primary me-3"></i>
										<div class="fs-5">Divers</div>
									</template>
								</div>
							</div>
						</div>

						<!-- Données extraites -->
						<div class="bg-white rounded-3 shadow-sm p-4">
							<div class="d-flex align-items-center mb-4">
								<i class="fas fa-receipt fa-lg text-primary me-2"></i>
								<h4 class="mb-0">Données extraites</h4>
							</div>

							<div class="row row-cols-1 row-cols-md-2 g-3">
								<div v-for="[key, data] in ticketListItems" :key="data.name" class="col">
									<div class="list-group-item list-group-item-action h-100">
										<div class="d-flex flex-column">
											<small class="text-muted">{{ translateLabel(data.name) }}</small>
											<div class="fw-bold mt-1">{{
													formatListItem(data.name, data.value)
												}}
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>

						<!-- Bouton d'enregistrement -->
						<div v-if="!expense" class="mt-4 d-flex justify-content-between">
							<n-button @click="back()" class="me-2">
								<template #icon>
									<i class="fas fa-arrow-left me-2"></i>
								</template>
								Retour
							</n-button>
							<n-button type="primary" @click="persist()">
								<template #icon>
									<i class="fas fa-save me-2"></i>
								</template>
								Enregistrer la note de frais
							</n-button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Loader from "../Loader.vue";
import {mapGetters} from "vuex";
import {formatDate, price} from "../../plugins/helpers.js";
import {NButton} from 'naive-ui';

export default {
	name: 'RecapNote',
	components: {
		Loader,
		NButton
	},
	props: {
		expense: {
			default: null,
		},
		rawexpense: {
			default: null,
		},
		image: String,
	},
	data() {
		return {
			category: null,
			ticketDatas: null,
			duplicates: []
		}
	},
	mounted() {
		this.checkDuplicate();
	},
	beforeMount() {
		if (this.expense) {
			this.category = this.expense.category;
			this.ticketDatas = this.expense.datas;
		} else {
			this.category = this.getCategory;
			this.ticketDatas = this.getTicketDatas;
		}
	},
	computed: {
		...mapGetters(['getCategory', 'getTicketDatas', 'getBase64Img', 'getUser']),
		ticketListItems() {
			const toFilter = ['date', 'totalttc', 'user', 'fournisseursiret', 'fournisseurtelephone', 'fournisseuremail', 'fournisseuradresse', 'fournisseursite'];
			return Object.entries(this.ticketDatas).filter(([key, value]) => !toFilter.includes(key));
		},
	},
	methods: {
		formatDate,
		price,
		checkDuplicate() {
			const date = this.ticketDatas['date']?.value;
			const totalttc = this.ticketDatas['totalttc']?.value;
			if (!date || totalttc === undefined || totalttc === null) {
				return;
			}
			this.$store.dispatch('checkDuplicateExpense', {
				date,
				totalttc,
				excludeId: this.expense ? this.expense.id : this.$route.params.id,
			}).then(res => {
				this.duplicates = res;
			}).catch(e => {
				console.error(e);
			});
		},
		persist() {
			const url = null;
			this.store(url).then(res => {
				this.$emit('saved', 'success');
				this.$router.push('/');
			}).catch(e => {
				this.$emit('saved', 'failure');
				console.error(e);
			});
		},
		store() {

			let self = this;

			let data = {
				id: self.$route.params.id,
				date: self.ticketDatas['date']?.value,
				category: self.getCategory,
				picture: self.getBase64Img,
				totalttc: self.ticketDatas['totalttc']?.value,
				totalht: self.ticketDatas['totalht']?.value,
				supplier: self.ticketDatas['fournisseurname']?.value,
				supplier_address: self.ticketDatas['fournisseuradresse']?.value,
				country: self.ticketDatas['pays']?.value,
				paiement_method: self.ticketDatas['modepaiement']?.value,
				comment: self.ticketDatas['comment']?.value,
				user: self.getUser.id,
				raw: {
					datas: self.ticketDatas,
					category: self.getCategory,
				}
			};

			if (self.ticketDatas['km']?.value) {
				data.odometer = self.ticketDatas['km']?.value;
			}
			if (self.ticketDatas['litre']?.value) {
				data.quantity = self.ticketDatas['litre']?.value;
			}

			console.log(data, 'data to send');

			return new Promise((resolve, reject) => {

				self.$store.dispatch('createTicket', data).then(res => {
					resolve(res);
				}).catch(e => {
					reject(e);
				});
			});
		},
		back() {
			this.$emit('changePath', 'dataValidation');
		},
		formatListItem(name, value) {
			const toPrice = ['totalttc', 'totalht', 'totaltva', 'tva_total1', 'tva_total2', 'tva_total3'];
			if (toPrice.includes(name)) {
				return price(value);
			}
			const toBoolean = ['signalerprobleme'];
			if (toBoolean.includes(name)) {
				return value ? 'Oui' : 'Non';
			}

			return value;
		},
		translateLabel(name) {
			const translations = {
				'totalht': 'Total HT',
				'totaltva': 'Total TVA',
				'tva_total1': 'TVA 1',
				'tva_total2': 'TVA 2',
				'tva_total3': 'TVA 3',
				'tva_%1': 'Taux TVA 1',
				'tva_%2': 'Taux TVA 2',
				'tva_%3': 'Taux TVA 3',
				'fournisseurname': 'Fournisseur',
				'fournisseurtva': 'N° TVA Fournisseur',
				'pays': 'Pays',
				'modepaiement': 'Mode de paiement',
				'comment': 'Commentaire',
				'commentaireprobleme': 'Description du problème',
				'km': 'Kilométrage',
				'litre': 'Litres',
				'signalerprobleme': 'Problème signalé'
			};
			return translations[name] || name;
		}
	}
}

</script>

<style scoped>

</style>